import { z } from "zod";

import type { FormCondition } from "./schemas";

import { OperatorValue } from "@/config/operatorConfig";
import type { SegmentField } from "@/features/segments/types";

const stringListSchema = z.array(z.string());

export const VALUE_INPUT = {
  NONE: "none",
  MULTI: "multi",
  TEXT: "text",
} as const;

export type ValueInputKind = (typeof VALUE_INPUT)[keyof typeof VALUE_INPUT];

export const getFieldLabel = (
  fields: SegmentField[],
  field: string,
): string => fields.find((candidate) => candidate.value === field)?.label ?? field;

export const parseListValue = (value: string | undefined): string[] => {
  if (typeof value !== "string") return [];
  try {
    return stringListSchema.catch([]).parse(JSON.parse(value));
  } catch {
    return [];
  }
};

export const hasConditionValues = (values: FormCondition["values"]): boolean =>
  values.length > 0 && values.every((value) => value.trim() !== "");

export const isLegacyCondition = (
  { field, operator }: Pick<FormCondition, "field" | "operator">,
  fields: SegmentField[],
): boolean => {
  if (!field) return false;
  const catalogueField = fields.find((candidate) => candidate.value === field);
  if (!catalogueField) return true;
  return operator !== undefined && !catalogueField.operators.includes(operator);
};

export const isConditionComplete = (
  condition: FormCondition,
): condition is FormCondition & { operator: OperatorValue } => {
  if (!condition.field || !condition.operator) return false;
  if (condition.operator === OperatorValue.IS_NULL) return true;
  return hasConditionValues(condition.values);
};
